import { render, staticRenderFns } from "./SingleStoreCard.vue?vue&type=template&id=13c44cb9"
import script from "./SingleStoreCard.vue?vue&type=script&lang=js"
export * from "./SingleStoreCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports